import * as React from "react"

const SvgBBIconsESGDetailScore = (props) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlSpace="preserve"
        style={{
            enableBackground: "new 0 0 200 200",
        }}
        viewBox="0 0 200 200"
        {...props}
    >
        <style>
            {
                ".st0,.st1{fill:none}.st1{stroke:#000;stroke-width:10;stroke-linecap:round;stroke-linejoin:round}.st2{fill:#fff}.st3{stroke:#000;stroke-width:3;stroke-miterlimit:10}.st4,.st5{fill-rule:evenodd;clip-rule:evenodd}.st5{stroke:#000;stroke-width:10;stroke-linecap:round;stroke-linejoin:round}.st6{display:none}.st7{display:inline}.st8{stroke:#000;stroke-width:5;stroke-linecap:round;stroke-linejoin:round}.st9{opacity:.9521}"
            }
        </style>
        <g id="Obecn\xE9_ikony">
            <path d="M100 55.7c-36.2 0-65.7 29.5-65.7 65.7 0 13.9 4.4 26.9 11.8 37.5h107.7c7.4-10.6 11.8-23.6 11.8-37.5.1-36.3-29.4-65.7-65.6-65.7zm8.7 70.1c-.1.2-.2.4-.4.6 0 .1-.1.1-.1.2l-.3.6c-.2.3-.4.6-.7.9-3.5 4.1-9.7 4.5-13.8 1-4.1-3.5-4.5-9.7-1-13.8.2-.3.5-.5.8-.8l.6-.5c.2-.2.4-.3.6-.5l4.2-3.4 39.7-32.7-29.6 48.4z" />
            <path d="M100 36.1c-47 0-85.2 38.2-85.2 85.2 0 13.9 3.4 27.7 9.9 40 .9 1.6 2.6 2.6 4.3 2.6.8 0 1.5-.2 2.3-.6 2.4-1.3 3.3-4.2 2-6.6-5.8-10.8-8.8-23.1-8.8-35.4 0-41.6 33.9-75.5 75.5-75.5s75.5 33.9 75.5 75.5c0 12.3-3 24.5-8.7 35.3-1.3 2.4-.4 5.3 2 6.6 2.4 1.3 5.3.4 6.6-2 6.5-12.2 9.9-25.9 9.9-39.8-.1-47-38.3-85.3-85.3-85.3z" />
        </g>
    </svg>
)

export default SvgBBIconsESGDetailScore;
